import { v4 as uuidv4 } from 'uuid'

export type Id = string

export function generateUniqId(): Id {
  return uuidv4()
}
